<div id="tutorial-description-area" [style.height]="TutorialStaticProps.customHeight + 'px'">
  <div id="tutorial-step-no">
    <div class="current-step-num">{{TutorialStaticProps.currentStep}}</div>
  </div>

  <div id="tutorial-title">操作方法: {{TutorialStaticProps.tutorialTitle}}</div>
  <div id="tutorial-body" [innerHTML]="TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1]?.content"></div>
  <div *ngIf="TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1]?.isNotRequiedManiplating && TutorialStaticProps.currentStep < TutorialStaticProps.steps.length" class="support-message"><span class="oi oi-arrow-circle-right pr-2"></span>操作は不要です。次のステップへ進んでください。</div>

  <footer>
    <div class="d-flex justify-content-end">
      <div>
        <button type="button" id="tutorial-step-cancel" class="btn btn-outline-dark mr-2" (click)="keep.cancel()">
          説明を中断
        </button>
      </div>

      <div>
        <button type="button" id="tutorial-step-prev" class="btn btn-outline-dark mr-2" disabled="{{TutorialStaticProps.currentStep === 1 ? true : null}}" (click)="keep.prev()">
          ◀︎前のステップへ
        </button>
      </div>

      <div *ngIf="TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1]?.skipStepValue >= 1">
        <button id="tutorial-step-skip" class="btn btn-primary mr-2" (click)="keep.next(TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1]?.skipStepValue)">
          {{TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1]?.skipButtonLabel}}
        </button>
      </div>

      <div>
        <button type="button" id="tutorial-step-next" class="btn btn-primary" (click)="keep.next()">
          <ng-container *ngIf="TutorialStaticProps.currentStep === TutorialStaticProps.steps.length">
            完了
          </ng-container>
          <ng-container *ngIf="TutorialStaticProps.currentStep !== TutorialStaticProps.steps.length">
            次のステップへ▶︎
          </ng-container>
        </button>
      </div>
    </div>
  </footer>
</div>
